import { type FC } from "react";
import { Presentation } from "./Presentation";
import { useTransportationInputs } from "./useTransportationInputs";
import { type ComponentHash } from "./type";

type Props = {
  componentHash: ComponentHash;
};

export const TransportationInputs: FC<Props> = ({ componentHash }) => {
  const transportationInputsData = useTransportationInputs(componentHash);

  if (!transportationInputsData) {
    return null;
  }

  return (
    <Presentation
      value={transportationInputsData.value}
      parentCheckboxId={transportationInputsData.parentCheckboxId}
      text={transportationInputsData.text}
      checked={transportationInputsData.checked}
      formNames={transportationInputsData.formNames}
      inputValues={transportationInputsData.inputValues}
      errors={transportationInputsData.errors}
      handleChangeCheckbox={transportationInputsData.handleChangeCheckbox}
      handleInputChange={transportationInputsData.handleInputChange}
    />
  );
};
